import { EventData, TicketData } from "../models/event";

const PUBLISHED_EVENT_STATUSES = ["published", "scheduled", "approved"];

export function isTicketSoldOut(ticket?: TicketData): boolean {
  if (!ticket) return false;
  if (ticket.status === "sold_out") return true;
  return Boolean(
    ticket.is_sold_out && (ticket.available_quantity ?? 0) <= 0,
  );
}

export function canMarkTicketSoldOut(event?: EventData): boolean {
  return PUBLISHED_EVENT_STATUSES.includes(event?.status || "");
}

/** Actual sold/reserved tickets — do not use quantity - available (wrong for manual sold-out). */
export function getTicketSoldQuantity(ticket?: TicketData): number {
  if (!ticket) return 0;

  const fromCounts =
    ticket.sold_count ?? ticket.active_registrations_count;

  if (fromCounts !== undefined && fromCounts !== null) {
    return Math.max(0, Number(fromCounts) || 0);
  }

  // Fallback only when counts are missing and ticket is not manually sold out
  if (isTicketSoldOut(ticket)) {
    return 0;
  }

  return Math.max(
    0,
    (ticket.quantity || 0) - (ticket.available_quantity || 0),
  );
}

